import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stockinRequestPO: null,
  loading: false,
  error: null,
};

const stockinRequestPOSlice = createSlice({
  name: "stockinRequestPO",
  initialState,
  reducers: {
    fetchStockinRequestPOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchStockinRequestPOSuccess: (state, action) => {
      state.loading = false;
      state.stockinRequestPO = action.payload;
      state.error = null;
    },

    fetchStockinRequestPOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchStockinRequestPOStart,
  fetchStockinRequestPOSuccess,
  fetchStockinRequestPOFailure,
} = stockinRequestPOSlice.actions;

export default stockinRequestPOSlice.reducer;
